'use client';

import React from 'react';
import classNames from 'classnames';
import { Text } from '@/design-system/components/Basic/Typography';

export interface ToggleProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  id,
  checked,
  onChange,
  label,
  disabled = false,
  className,
}) => {
  return (
    <div className={classNames('flex items-center gap-3', className)}>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className="sr-only peer"
        />
        {/* Toggle background */}
        <div
          className={classNames('w-11 h-6 rounded-full transition-colors duration-300 relative', {
            'bg-ds-bg-surface-2': checked,
            'bg-ds-bg-surface-soft-1': !checked,
            'opacity-50 cursor-not-allowed': disabled,
          })}
        />
        {/* Toggle knob */}
        <span
          className={classNames(
            'absolute left-0.5 top-0.5 h-5 w-5 bg-white rounded-full shadow-md',
            'transition-transform duration-300',
            {
              'translate-x-5': checked,
            },
          )}
        />
      </label>
      {label && (
        <Text size="default" className="text-ds-text-1">
          {label}
        </Text>
      )}
    </div>
  );
};

export default Toggle;
